import * as Yup from "yup";
import "yup-personnummer";

const sssRegex = /^(19|20)(\d{6}([-+]|\s)\d{4}|(?!19|20)\d{10})$/;
// const mobileRegex = /^((\+|00)46\s?|0)[7|8|9]\d{1}\s?\d{3}\s?\d{2}\s?\d{2}$/;
// const sssRegex =
// /^(19|20)(\d{2}0[1-9]|1[0-2]([-]|\s)\d{4}|(?!19|20)\d{2}0[1-9]|1[0-2]\d{4})$/;
const mobileRegex = /^((([+]|00)46)\s*(7)|07)[02369]\s*(\d{4})\s*(\d{3})$/;
const zipRegex = /^\d{3}\s?\d{2}$/;

export const yupOrderFormSchema = Yup.object().shape({
  firstname: Yup.string().trim().required("Obligatoriskt"),
  lastname: Yup.string().trim().required("Obligatoriskt"),
  email: Yup.string()
    .trim()
    .email("Ogiltig e-postadress")
    .required("Obligatoriskt"),
  mobile: Yup.string()
    .trim()
    .matches(mobileRegex, "Felaktigt mobilnummer")
    .required("Obligatoriskt"),
  personalnumber: Yup.string()
    .trim()
    .matches(sssRegex, "Felaktigt personnummer, formatet är ÅÅÅÅMMDD-XXXX")
    .required("Obligatoriskt"),
  address_street: Yup.string().trim().required("Obligatoriskt"),
  address_streetno: Yup.number()
    .typeError("Nog bor du väl på ett nummer?")
    .required("Obligatoriskt"),
  address_letter: Yup.string(),
  address_co: Yup.string(),
  address_apartment: Yup.string(),
  address_zip: Yup.string()
    .matches(zipRegex, "Oj, det var ett konstigt postnummer")
    .required("Obligatoriskt"),
  address_city: Yup.string().required("Obligatoriskt"),
  // invoice_street: Yup.string().required("Obligatoriskt"),
  // invoice_streetno: Yup.string().required("Obligatoriskt"),
  // invoice_letter: Yup.string(),
  // invoice_co: Yup.string(),
  // invoice_apartment: Yup.string(),
  // invoice_zip: Yup.string().required("Obligatoriskt"),
  // invoice_city: Yup.string().required("Obligatoriskt"),
  message: Yup.string(),
});
